import React from 'react';
import '../../assets/css/loader.css';

const Loader = ({showMessage , text}) => {
  return (
    <div className="loaderOuter">
      <div className="loader"></div>
      {showMessage && <p className="loaderText">{text}</p>}
    </div>
  );
};

export default Loader;
